import React from 'react';

const StructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Lawsutra",
    "applicationCategory": "Legal Research Software",
    "operatingSystem": "Web-based",
    "description": "India's premier AI-powered legal research platform providing comprehensive access to Indian law, court cases, and legal analytics.",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "INR"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "127"
    },
    "provider": {
      "@type": "Organization",
      "name": "Lawsutra",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "IN"
      }
    },
    "keywords": "legal tech india, AI legal assistant, Indian law research, legal technology, supreme court cases"
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(structuredData)}
    </script>
  );
};

export default StructuredData; 